module.exports = __webpack_public_path__ + "static/media/ic-arrow-white-20.a356a7da.svg";